module.exports = __webpack_public_path__ + "media/images/logos/logo-deloitte-414367deb98995388a566fb4d392d118.svg";